import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen inset-0 bg-gradient-to-r from-purple-900/90 to-purple-600/70 text-center overflow-hidden px-6">
      {/* Floating glow orbs */}
      <div className="absolute w-72 h-72 bg-white/10 rounded-full blur-3xl top-20 left-10 animate-pulse -z-10"></div>
      <div className="absolute w-72 h-72 bg-white/10 rounded-full blur-3xl bottom-20 right-10 animate-pulse delay-300 -z-10"></div>

      {/* Animated 404 text */}
      <motion.h1
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="text-[6rem] md:text-[8rem] font-extrabold text-white drop-shadow-[0_0_20px_rgba(255,255,255,0.2)]"
      >
        404
      </motion.h1>

      {/* Message */}
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="text-white/90 text-lg md:text-xl max-w-lg mt-4"
      >
        Oops! The page you’re looking for has gone missing — maybe it melted away 🍭
      </motion.p>

      {/* Back to Home Button */}
      <motion.button
        onClick={() => navigate("/")}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.4 }}
        className="z-10 mt-8 flex items-center gap-2 px-8 py-3 bg-white/20 backdrop-blur-md hover:bg-white/30 text-white font-medium rounded-full shadow-lg transition-all duration-300 hover:scale-105 border border-white/40"
      >
        <ArrowLeft className="w-5 h-5" />
        Back to Home
      </motion.button>

      {/* Branding */}
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.6 }}
        className="mt-12 text-3xl font-bold text-white"
      >
        E-<span className="text-yellow-300">Learning</span>
      </motion.h2>

      {/* Subtext */}
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.8, y: [0, -6, 0] }}
        transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
        className="text-white/70 text-sm mt-4"
      >
        Learn and get on demand skills here 🍬
      </motion.p>

      {/* Subtle bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black/20 to-transparent -z-10"></div>
    </div>
  );
}
